import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';
import { isDayforce } from '../../../../settings';

const initState = {
  workers: [],
  payoutsOptions: [],
  filteredCount: 0,
  totalCount: 0,
  loading: false,
};

const getKey = payout => payout.organization.id + payout.payout.code + payout.billable.toString();

function isDisabledBenchUser(worker, startAppSettings) {
  return isDayforce() && worker.worker && worker.worker.organization.id !== startAppSettings.organization.id;
}

function onClearStore() {
  return { ...initState };
}

function onLoadData(state) {
  return { ...state, loading: true };
}

function onLoadDataSuccess(state, { payload, startAppSettings }) {
  const { workers, filteredCount, totalCount, payoutsOptions } = payload;
  const allPayouts = [];

  workers.forEach(worker => {
    if (isDisabledBenchUser(worker, startAppSettings)) {
      worker.disabled = true;
    }

    worker.assigned_payouts.forEach(payout => {
      const key = getKey(payout);

      if (!allPayouts.find(item => getKey(item) === key)) {
        allPayouts.push({ ...payout, amount: 0, id: undefined });
      }
    });
  });

  workers.forEach(worker => {
    allPayouts.forEach((payout, index) => {
      const key = getKey(payout);

      if (!worker.assigned_payouts.find(item => getKey(item) === key)) {
        worker.assigned_payouts.splice(index, 0, { ...payout });
      }
    });
  });

  return {
    ...state,
    workers,
    payoutsOptions,
    filteredCount,
    totalCount,
    loading: false,
  };
}

function formatPayout(payout, billable, organization) {
  const { can_be_billable, code, id, max_limit, description } = payout;

  return {
    amount: 0,
    billable,
    // id,
    max_limit,
    description,
    organization,
    payout: { can_be_billable, code, id },
  };
}

function onAddPayout(state, { payload, startAppSettings }) {
  const { payout, billable, organization } = payload;
  const workers = state.workers.map(worker => {
    if (isDisabledBenchUser(worker, startAppSettings)) {
      return { ...worker };
    }

    return { ...worker, assigned_payouts: [...worker.assigned_payouts, formatPayout(payout, billable, organization)] };
  });

  return { ...state, workers };
}

function onChangePayoutValue(state, { payload, startAppSettings }) {
  const {
    value,
    worker: { id },
    key,
  } = payload;

  const workers = state.workers.map(worker => {
    const newWorker = { ...worker, assigned_payouts: [...worker.assigned_payouts] };

    if (isDisabledBenchUser(newWorker, startAppSettings) || newWorker.id !== id) {
      return newWorker;
    }

    const index = newWorker.assigned_payouts.findIndex(payout => getKey(payout) === key);

    if (index === -1) {
      return newWorker;
    }
    newWorker.assigned_payouts[index].amount = value || 0;

    return newWorker;
  });

  return { ...state, workers };
}

function onFillColumn(state, { payload, startAppSettings }) {
  const { value, key } = payload;
  const workers = state.workers.map(worker => {
    const newWorker = { ...worker, assigned_payouts: [...worker.assigned_payouts] };

    if (isDisabledBenchUser(newWorker, startAppSettings)) {
      return newWorker;
    }
    const index = newWorker.assigned_payouts.findIndex(payout => getKey(payout) === key);

    if (index === -1) {
      return newWorker;
    }
    newWorker.assigned_payouts[index].amount = value || 0;

    return newWorker;
  });

  return { ...state, workers };
}

function onDeletePayout(state, { payload, startAppSettings }) {
  const { key } = payload;
  const workers = state.workers.map(worker => {
    const newWorker = { ...worker, assigned_payouts: [...worker.assigned_payouts] };

    if (isDisabledBenchUser(newWorker, startAppSettings)) {
      return newWorker;
    }
    const index = newWorker.assigned_payouts.findIndex(payout => getKey(payout) === key);

    if (index === -1) {
      return newWorker;
    }
    newWorker.assigned_payouts.splice(index, 1);

    return newWorker;
  });

  return { ...state, workers };
}

export default createReducer(initState, {
  [actions.ADD_PAYOUT]: onAddPayout,
  [actions.CHANGE_PAYOUT_VALUE]: onChangePayoutValue,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.DELETE_PAYOUT]: onDeletePayout,
  [actions.FILL_COLUMN]: onFillColumn,
  [actions.LOAD_DATA]: onLoadData,
  [actions.LOAD_DATA_SUCCESS]: onLoadDataSuccess,
});
